
import * as cloudinaryRuntime$x02pc4ecPZatpmU4MfjMtt23xniDo4EA6Ln2QUIKpmw from '/opt/render/project/src/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@9.1.1_db0@0.3.4_better-sqlite3@11.10.0__ioredis@5.8.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/cloudinary'
import * as cmsProviderRuntime$kP0fe4QLg3oL4iIWR83wlIYHB3eeihlWsLbC6P85wcg from '/opt/render/project/src/apps/refresh/providers/cms.js'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1920,
    "2xl": 1536
  },
  "presets": {},
  "provider": "cloudinary",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['cloudinary']: { provider: cloudinaryRuntime$x02pc4ecPZatpmU4MfjMtt23xniDo4EA6Ln2QUIKpmw, defaults: {"baseURL":"https://res.cloudinary.com/djurensratt/image/upload"} },
  ['cmsProvider']: { provider: cmsProviderRuntime$kP0fe4QLg3oL4iIWR83wlIYHB3eeihlWsLbC6P85wcg, defaults: {"baseURL":"https://res.cloudinary.com/djurensratt/image/fetch"} }
}
        